/* Psiqueactiva · comportamientos compartidos (adaptado a Shopify).
   - La navegación viene del snippet psi-header.
   - En el EDITOR de temas todo se muestra al instante (sin animación de entrada),
     y se reinicializa cuando el editor redibuja, agrega u oculta una sección/bloque. */
(function(){
function isEditor(){ return !!(window.Shopify && window.Shopify.designMode); }

function init(){
  if (!document.hidden) document.documentElement.classList.add('js');

  // En el editor: revelar TODO de inmediato y no esconder nada (evita que el
  // contenido desaparezca al editar/ocultar/mostrar bloques).
  if (isEditor()){
    document.querySelectorAll('.reveal').forEach(el => {
      el.style.transition = 'none';
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.classList.add('in');
    });
  }

  // Header scroll state
  const nav = document.getElementById('nav');
  if (nav && !nav.dataset.psiBound){
    nav.dataset.psiBound = '1';
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive:true });
  }

  // Mobile menu
  const menuBtn = document.getElementById('menuBtn');
  const mobileMenu = document.getElementById('mobileMenu');
  if (menuBtn && mobileMenu && !menuBtn.dataset.psiBound){
    menuBtn.dataset.psiBound = '1';
    menuBtn.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }));
  }

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(q => {
    if (q.dataset.psiBound) return;
    q.dataset.psiBound = '1';
    q.addEventListener('click', () => {
      const open = q.getAttribute('aria-expanded') === 'true';
      const a = q.nextElementSibling;
      q.setAttribute('aria-expanded', !open);
      a.style.maxHeight = open ? null : a.scrollHeight + 'px';
    });
  });

  if (isEditor()) return; // en el editor no animamos

  // Reveal on scroll (tienda real)
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal:not(.in)').forEach((el, i) => {
    el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
    io.observe(el);
  });
  // Seguro anti-contenido-invisible: SOLO lo que ya está en el viewport.
  // (Antes revelaba TODO y mataba la animación al hacer scroll.)
  setTimeout(() => document.querySelectorAll('.reveal:not(.in)').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0){
      el.style.transition = 'none';
      el.classList.add('in');
    }
  }), 1400);
}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Editor de temas: reinicializar al cargar/seleccionar/reordenar secciones y bloques
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  document.addEventListener('shopify:block:select', init);
})();
